import { TFunction } from 'i18next'

export const getTagLabel = (
  options: { value: number; label: string }[],
  tag: number,
  t: TFunction,
) =>
  options.find(item => item.value === tag)?.label || t('common:error_messages.something_went_wrong')
